import React from 'react';
import { render } from 'react-dom';
import PlpSeoContainer from './components/PlpSeoContainer';
import '@babel/polyfill';

const App = () => {
	return <PlpSeoContainer />;
};

render(React.createElement(App), document.getElementById('plp-seo-app-bottom'));
